import { getDateString } from '~/server/formatters';
import { getPostActionString } from '~/post/helpers';

export const getDraftDetails = ({
  draft,
  profileTimezone,
  twentyFourHourTime,
  isDraftsView,
}) => {
  const { createdAt } = draft;
  const servicesWithCommentFeature = ['instagram'];
  const createdAtString = getDateString(createdAt, profileTimezone, {
    createdAt,
    twentyFourHourTime,
  });
  let avatarUrl = '';
  if (draft.user) {
    avatarUrl = draft.user.avatar || draft.user.gravatar;
  }

  return {
    draftId: draft.id,
    via: draft.via,
    creatorName: draft.user ? draft.user.name : '',
    email: draft.user ? draft.user.email : '',
    avatarUrl,
    createdAt: createdAtString,
    postAction: getPostActionString({
      post: draft,
      profileTimezone,
      twentyFourHourTime,
      isDraftsView,
    }),
    isRetweet: draft.retweet !== undefined,
    commentText: draft.commentText,
    hasCommentEnabled:
      servicesWithCommentFeature.indexOf(draft.profile_service) !== -1,
    shopgridLink: draft.shopgridLink,
  };
};

// Could export this to utils and then pull it in and pass tab depending on which package uses it
export const formatPostLists = (
  profile,
  drafts,
  user,
  tabId,
  hasApprovalFeature
) => {
  const profileTimezone = profile.timezone;
  const { isManager } = profile;
  const twentyFourHourTime = user.twentyfour_hour_time;

  // Drafts tab only displays drafts that don't need approval.
  // Approval tabs only display drafts that need approval.
  const isDraftsView = tabId === 'drafts';
  const draftsList = Object.values(drafts).filter(
    (draft) => draft.needsApproval !== isDraftsView
  );
  const typeOfTab = isDraftsView ? 'drafts' : 'approval';

  return draftsList.reduce((acc, draft, index) => {
    acc.push({
      queueItemType: 'post',
      hasPermission:
        isManager || user.id === (draft.user ? draft.user.id : draft.id),
      role: profile.organizationRole,
      manager: isManager,
      draftDetails: getDraftDetails({
        draft,
        profileTimezone,
        twentyFourHourTime,
        isDraftsView,
        hasApprovalFeature,
      }),
      view: typeOfTab,
      index,
      ...draft,
    });
    return acc;
  }, []);
};
